"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapShades = void 0;
var _utils = require("../utils");
var _internal = require("../utils/internal");
var _mapShade = require("./mapShade");
const mapShades = shades => {
  if (shades) {
    return (0, _utils.filterShades)(shades).map(_mapShade.mapShade).filter(_internal.filterDiscontinuedShade);
  }
  return null;
};
exports.mapShades = mapShades;
